<template>
  <div class="questions">
    <div class="banner"></div>
    <div class="login-input">
      <div class="login-input-cnt">
        <mt-field class="label-input" type="tel" label="手机号" placeholder="请输入手机号" v-model="mobileNumber" @blur.native.capture="mobileValidation"></mt-field>
        <mt-field class="label-input" label="验证码" placeholder="请输入验证码" v-model="registLoginData.form.identifyCode">
          <mt-button @click="getCode" style="color:#00B2A9" type="default">{{getCodeData.getcodetxt}}</mt-button>
        </mt-field>
        <fade-animation>
          <div class="checkOut" >
            <span v-show="registLoginData.visible">{{registLoginData.regTipInfo}}</span>
          </div>
        </fade-animation>
        <mt-button @click="registLoginGetToken" :class="getCodeData.disabled ? 'disBtn':'login-btn'" class="label-input" :disabled="getCodeData.disabled" type="primary" size="large">登录</mt-button>
      </div>
    </div>
    <div class="fuzzy" v-if="getCodeData.isImgCode">
      <div class="promt">
        <div class="title"><p>输入验证码</p></div>
        <div class="imgCode">
          <mt-field placeholder="请输入右侧验证码" v-model="getImgCodeData.form.imgCode" class="identifyCode">
            <img :src="getImgCodeData.imgdata" height="45px" width="100px" @click="changeImgCode">
          </mt-field>
        </div>
        <div class="test">
          <span v-if="getImgCodeData.visible">{{getImgCodeData.checkVal}}</span>
        </div>
        <div class="btn">
          <mt-button  class="default" @click="getCodeData.isImgCode = false">取消</mt-button>
          <mt-button class="primary" @click="confirmCode">确认</mt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  // 获取验证码
  getCodeRequest,
  // 注册登录
  loginRequest,
  // 获取图片验证码
  getImgCodenRequest,
  // 验证图片验证码
  confirmImgCodenRequest
} from '@/data/api/common/Login/Login.js'
import FadeAnimation from '@/components/Fade/FadeAnimation'
import Cookie from '@/common/utils/Cookie.js'
import { validateMobile } from '@/common/validate/validate.js'
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
import { setUserId } from '@/common/utils/cookieHandler'

export default {
  name: 'QuestionsPage',
  components: {
    FadeAnimation
  },
  data () {
    return {
      mobileNumber:'',
      getCodeData: {
        getcodetxt: '获取验证码',
        isImgCode: false,
        getCodeClickBtn: true,
        errCode: '',
        disabled: true,
        form: {
          mobile: '',
          // 司机或乘客 1乘客 2司机
          userType: 1,
          // 使用场景
          templateCode: '0002',
          // 图像验证码ID
          imgId: '',
          // 图像验证码code
          imgCode: ''
        }
      },
      registLoginData: {
        form: {
          mobile: '',
          // 验证码
          identifyCode: '',
          // 图片验证码ID
          imgId: '',
          // 图片验证码
          imgCode: ''
        },
        visible: false,
        regTipInfo: ''
      },
      getImgCodeData: {
        imgdata: '',
        checkVal: '',
        visible: false,
        form: {
          imgId: '',
          imgCode: ''
        }
      },
      validatorFlag:false
    }
  },
  mounted () {
    UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: false})
  },
  methods: {
    // 获取验证码
    getCode () {
      UpdateLogData({path: this.$route.path, action: 'sendCode', hasRedPacket: false})
      let self = this
      this.getCodeData.form.mobile = this.mobileNumber.split(" ").join("")
      this.$route.query.resource ? this.getCodeData.form.resource = this.$route.query.resource : ''
      if (self.getCodeData.getCodeClickBtn) {
        if (this.getCodeData.errCode === -200140) {
          this.getCodeData.isImgCode = true
          this.getImgCodeData.form.imgCode = ''
          this.getImgCode()
        } else {
          if ((validateMobile(this.getCodeData.form.mobile)).status) {
            this.registLoginData.visible = false
            self.timeCutdowm(self.getCodeData)
            // 获取短信验证码
            getCodeRequest(this.getCodeData.form).then(res => {
              this.getCodeData.form.imgId = ''
              this.getCodeData.form.imgCode = ''
            }).catch(err => {
              if (err.data.errCode === -200140) {
                this.getCodeData.errCode = err.data.errCode
                this.getCodeData.isImgCode = true
                this.getImgCodeData.form.imgCode = ''
                this.getImgCode()
              }
            })
          } else {
            this.registLoginData.visible = true
            this.registLoginData.regTipInfo = '手机号格式有误'
          }
        }
      } else {
        return false
      }
    },
    // 获取图片验证码
    getImgCode: function () {
      getImgCodenRequest().then((response) => {
        this.getImgCodeData.imgdata = 'data:image/png;base64,' + response.imgData
        this.getImgCodeData.form.imgId = response.imgId
        this.getCodeData.form.imgId = response.imgId
      })
    },
    // 改变图片验证码
    changeImgCode: function () {
      this.getImgCode()
    },
    // 确认图片验证码
    confirmCode: function () {
      confirmImgCodenRequest(this.getImgCodeData.form).then((response) => {
        this.getCodeData.isImgCode = false
        this.getImgCodeData.visible = false
        this.getCodeData.errCode = 0
        this.getCodeData.form.imgCode = this.getImgCodeData.form.imgCode
      }).catch((response) => {
        this.getImgCodeData.visible = true
        this.getImgCodeData.checkVal = response.data.errMsg
      })
    },
    // 注册登录获取token
    registLoginGetToken () {
      UpdateLogData({path: this.$route.path, action: 'login', hasRedPacket: false})
      this.getCodeData.form.mobile = this.mobileNumber.split(" ").join("")
      if ((validateMobile(this.getCodeData.form.mobile)).status) {
        this.registLoginData.visible = false
        this.registLoginData.form.mobile = this.getCodeData.form.mobile
        this.$route.query.resource ? this.registLoginData.form.resource = this.$route.query.resource : ''
        this.$mint.Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        loginRequest(this.registLoginData.form).then(res => {
          setUserId(res.uid)
          const TokenKey = 'Admin-Token'
          Cookie.set(TokenKey, res.accessToken)
          if(res.registration == true){
            window.location.href = window.location.pathname + '#/experienceExplist'
            document.title = '首席体验官招募令'
          }else{
            window.location.href = window.location.pathname + '#/questionsAnswer'
            document.title = '问卷答题'
          }
        }).catch((res) => {
          this.registLoginData.visible = true
          this.registLoginData.regTipInfo = res.data.errMsg
          this.getCodeData.errCode = res.data.errCode
          // 登录失败 删除token
          Cookie.del('Admin-Token')
        }).finally(() => {
          this.$mint.Indicator.close()
        })
      } else {
        this.registLoginData.visible = true
        this.registLoginData.regTipInfo = ''
      }
    },
    // 倒计时
    timeCutdowm (obj) {
      if (!obj.getCodeClickBtn) { return }
      var time = 60 || obj.time
      obj.getCodeClickBtn = false
      obj.getcodetxt = time + 's后可重发'
      if (obj.timer) {
        clearInterval(obj.timer)
      }
      obj.timer = setInterval(function () {
        time--
        obj.getcodetxt = time + 's后可重发'
        if (time <= 0) {
          clearInterval(obj.timer)
          obj.getcodetxt = '获取验证码'
          obj.getCodeClickBtn = true
        }
      }, 1000)
    },
    // 清理定时器
    clearIntervalTimer () {
      if (this.getCodeData.timer) {
        clearInterval(this.getCodeData.timer)
      }
    },
    mobileValidation(){
      this.getCodeData.form.mobile = this.mobileNumber.split(" ").join("")
      let validator = validateMobile(this.getCodeData.form.mobile)
      if (!validator.status || isNaN(this.getCodeData.form.mobile)) {
          this.validatorFlag = true
          this.registLoginData.visible = true
          this.getCodeData.disabled = true
          this.registLoginData.regTipInfo = '手机号格式有误'
      }else{
          this.registLoginData.visible = false
          this.getCodeData.disabled = false
      }      
    }

  },
  watch: {
    'mobileNumber': function (val, oldVal) {
      if (val.length > oldVal.length) { // 文本框中输入
        if (val.length === 4 || val.length === 9) {
          this.mobileNumber = oldVal + ' ' + val[val.length-1]
        }
      } else { // 文本框中删除
        if (val.length === 9 || val.length === 4) {
          this.mobileNumber = this.mobileNumber.trim()
        }
      }
      if(this.validatorFlag) this.mobileValidation()
    },
    'getImgCodeData.form.imgCode': function (val, oldVal) {
      this.getImgCodeData.visible = false
    },
    'registLoginData.form.identifyCode': function (val, oldVal) {
      this.registLoginData.visible = false
      this.getCodeData.disabled = false
      if (val === '') {
        this.getCodeData.disabled = true
      }
    }
  },
  destroyed () {
    this.clearIntervalTimer()
  }
}
</script>
<style lang="stylus">
.questions{
  .mint-cell-text{
    vertical-align:baseline
  }
}
body{
  font-family:PingFang SC
}
input{
  font-family:PingFang SC  
}
</style>

<style scoped lang="stylus">

.questions{
  position: absolute;
  left:0;
  top:0;
  bottom:0;
  width:100%;
  overflow: hidden;
  .banner{
    position: fixed;
    width: 100%;
    top: 0;
    bottom: 0;
    background: url(../../assets/images/question/indexbg.jpg) no-repeat 0 0 #01b2a8;
    background-size: 100%;
  }
  .login-input{
    width:100%;
    box-sizing: border-box;
    padding:0 10px 10px;
    position: absolute;
    top: 32%;
    bottom: 0;
    .login-input-cnt{
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding:20px;
      border:4px solid #AFF8F4;
      border-radius:0.6125rem;
      background-color:#fff;
      >>> .comp-input{
        border: 1px solid #b9cbcf
        border-radius: 0.3125rem
      }
      .label-input{
        margin-top: 30px;
        border: 0.0367rem solid #B9CBCF;
        border-radius: 5px;
        color: #333;
        font-size:16px;
        >>> .mint-cell-wrapper{
          background-image:none;
        }
        >>> .mint-cell-wrapper .mint-cell-title{
          width: 60px;
        }
        >>> .mint-cell-value .mint-field-core{
          background:none;
        }
        >>> .mint-cell-value .mint-field-core::-webkit-input-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core::-moz-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core:-moz-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core:-ms-input-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-other:before{
          position: absolute;
          left: 5px;
          top: 24%;
          content: '';
          display:block;
          width:0.0725rem;
          height:60%;
          background-color:#ddd;
        }
        >>> .mint-cell-value .mint-field-other .mint-button--default{
          color:#ccc;
          background-color:transparent;
          box-shadow:none;
          font-size:16px;
        }
         >>> .mint-cell-value .mint-field-other .mint-button--normal{
          padding:none !important
        }
      }
      .checkOut{
        font-size:13px;
        color:#FF0000
        margin-top:10px;
        height:24px;
      }
      .login-btn{
        background:linear-gradient(#7ED8D5, #24BBCC);
        color:#fff;
        font-size:18px;
        border: none;
        height: 50px;
        margin-top:14px;
      }
      .disBtn{
        background: rgba(218,226,228,1);
        color:#fff;
        font-size:18px;
        border: none;
        height: 50px;
        margin-top:14px;
      }
    }
  }
  .fuzzy{
    width:100%;
    height:100%;
    position :fixed;
    top:0;
    background :rgba(0,0,0,0.4);
    z-index:100
    .promt{
      width:84%;
      min-height:220px;
      background :#fff;
      z-index:1000;
      border-radius :10px;
      margin:6rem 8%;
      .title{
        height: 4rem;
        text-align: center;
        line-height: 4rem;
        font-size: 16px;
        color: #333;
      }
      .imgCode{
        margin:0rem 1rem
        border-bottom:1px solid #eee;
        padding-bottom:0.3rem
        .identifyCode{
          background-image :none !important
          margin-top:1.6rem;
           >>>.mint-cell-wrapper{
             background-image :none !important
           }
        }
      }
      .test{
        font-size:13px;
        color:#FF0000;
        margin:0.5rem 1rem;
        height:22px;
      }
      .btn{
        margin-top:0.8rem;
        padding-bottom:20px;
        .default{
          width: 41%;
          margin:0 4% 0 6%
          color: #89ABA5;
          background: #fff;
          border:1px solid #89ABA5;
          font-size: 15px;
        }
        .primary{
          width: 41%;
          color: #fff;
          background: #00B2A9;
          font-size: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Questions/index.vue